import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@paypalcorp/pp-react';
import { appendCdnHostName } from '../../../lib/geoUtils';
import { Message } from '@paypalcorp/worldready-react';

class NextButtonComponent extends React.Component {
  render() {
    return (
      <Button
        branded
        className="btn-wide next-button"
        id="payWithPP"
        disabled={this.props.disabled}
        onClick={this.props.handleNext}
      >
        <img
          src={appendCdnHostName('/paypal-ui/logos/svg/paypal-mark-color.svg')}
          style={{ height: '24px', width: '24px', marginRight: '8px' }}
        />
        <Message id="common.nextButton.button.next" />
      </Button>
    );
  }
}

NextButtonComponent.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  handleNext: PropTypes.func,
};

export default NextButtonComponent;
